module.exports = __webpack_public_path__ + "static/media/impiantoWhite.ac7eb890.png";